import { apiRTK, Tag } from 'api/api-rtk'

import type { Subscription } from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		subscription: create.query<Subscription, void>({
			providesTags: [Tag.Subscription],
			query: () => ({
				url: 'subscription'
			})
		}),

		upgrade: create.mutation<unknown, string>({
			invalidatesTags: [Tag.Subscription],
			query: id => ({
				data: {
					plan_id: id
				},
				method: 'PUT',
				url: 'subscription/upgrade'
			})
		})
	}),
	overrideExisting: true
})
